<template>
  <div class="card" ref='screen'
       v-if="viz1.visibleFlag === true && viz1.vizType!=='report' && viz1.vizletCardDisableFlag == false"
       v-bind:style="vizletCardStyle"
       :class="[
       $store.state.bannerStatus
         ? (vizCount === 1 ? 'single-viz-height-banner-true' : 'single-viz-max-height-banner-true')
         : (vizCount === 1 ? 'single-viz-height-banner-false' : 'single-viz-max-height-banner-false'),
       { 'fixed-screen-width': $store.state.fixedScreen }
     ]">

    <!-- Tab indicator in header -->
    <div class="card-header p-0" v-if="vizCount!==1">
      <vizlet-header
          :viz1="viz1"
          :currentMenuActionIconsData="currentMenuActionIconsData"
          :mCurrentMenuActionIconsData="mCurrentMenuActionIconsData"
          :vizCount="vizCount"
          :searchQuery.sync="searchQuery"
          :iconOnChangeFlag="iconOnChangeFlag"
          :isCollapsed="isCollapsed"
          :format="format"
          :total="total"
          @toggle-body="toggleCardBody"
          @toggle-width="toggleCardWidth"
          @action="handleActionIconFunctionCall"
          @reset-filter="resetFilter"
          @search="handleSearch"
      />
    </div>

    <!-- Resize handles -->
    <div class="resize-handle" @mousedown.prevent="startBorderResize($event, 'se')">⇲</div>
    <div class="resize-border resize-border-right" @mousedown.prevent="startBorderResize($event, 'e')"></div>
    <div class="resize-border resize-border-bottom" @mousedown.prevent="startBorderResize($event, 's')"></div>

    <!-- Card Body Content (unchanged) -->
    <div v-if="!(viz1.viztypeName === 'TableBar' || viz1.viztypeName === 'Tabulator' || viz1.viztypeName ==='fileUpload')" class="card-body"
         v-show="!isCollapsed">
      <div v-if="tooltipTitle==='Lower the Better'" align="right" v-bind:style="{ color:colorClass}">
        <i class="fa fa-arrow-circle-down" :title="tooltipTitle"></i>
      </div>
      <div v-if="tooltipTitle==='Higher the Better'" align="right" v-bind:style="{ color:colorClass}">
        <i class="fa fa-arrow-circle-up" :title="tooltipTitle"></i>
      </div>

      <div :id="id" ref="r1c1" :class="viz1.scrollbarFlag? 'scrollmenu2' : 'scrollmenu'"></div>
    </div>

    <div v-if="viz1.viztypeName=='TableBar'" class="card-body p-0" v-show="!isCollapsed">
      <div v-if="tooltipTitle==='Lower the Better'" align="right" v-bind:style="{ color:colorClass}">
        <i class="fa fa-arrow-circle-down" :title="tooltipTitle"></i>
      </div>
      <div v-if="tooltipTitle==='Higher the Better'" align="right" v-bind:style="{ color:colorClass}">
        <i class="fa fa-arrow-circle-up" :title="tooltipTitle"></i>
      </div>

      <div
          :id="id"
          ref="r1c2"
          :class="vizCount > 1 ? 'multi-viz' : ($store.state.bannerStatus ? 'r1c2true' : 'r1c2false')"
          :style="dynamicStyle">
      </div>
    </div>

    <b-modal
        ref="download-modal"
        title="Downloading Data"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        hide-footer
    >
      <div class="text-center">
        <b-spinner variant="primary" class="mb-3"></b-spinner>
        <p class="mb-0">Preparing your download... Please wait.</p>
      </div>
    </b-modal>

    <div v-if="viz1.viztypeName==='Tabulator' && tabFlag" class="card-body p-1" v-show="!isCollapsed">
      <tabulator-report-table ref="tabulatorReport" :id="id" class="scrollmenuRepo" :viz1="viz1"
                              :tabulatorData="tabulatorData" :filters="filtersForDashboard" :vizCount="vizCount"/>
    </div>

    <div v-if="viz1.viztypeName==='salesDashboard'" class="card-body p-1" v-show="!isCollapsed">
      <sales-dashboard ref="salesDashboard" class="scrollmenuRepo" :id="id" :viz1="viz1" :filters="filtersForDashboard"
                       :sales-data="salesData"/>
    </div>

    <div v-if="viz1.viztypeName==='salesDashboardv1'" class="card-body p-1" v-show="!isCollapsed">
      <sales-dashboard-v1 ref="salesDashboardv1" class="scrollmenuRepo" :id="id" :viz1="viz1" :filters="filtersForDashboard"
                          :sales-data="salesData"/>
    </div>

    <div v-if="viz1.viztypeName==='fileUpload'" class="card-body p-2" v-show="!isCollapsed">
      <file-upload/>
    </div>

    <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
      <b-form-group label="Comment">
        <textarea rows="3" cols="40" v-model="cmnt" placeholder="Write a comment..."></textarea>
      </b-form-group>
    </b-modal>

    <div>
      <modal
          v-if="showErrorModal"
          :isVisible="showErrorModal"
          @close="showErrorModal = false"
          :title="title"
      >
      </modal>
    </div>
  </div>
  <div v-else-if="viz1.vizletCardDisableFlag==true" :id="id" ref="r1c1"></div>
</template>

<script>
import {FwVizChartInfo} from "../models";
import axios from "axios";
import moment from 'moment';
import {saveSvgAsPng} from "save-svg-as-png";
import * as d3 from "d3";
import TabulatorReportTable from "./reports/tabulator-report-table.vue";
import Modal from "./Modal.vue";
import SalesDashboard from "@/components/SalesDashboard.vue";
import SalesDashboardV1 from "@/components/SalesDashboardV1.vue";
import {getAnnotationMsgcount} from "@/common/functions";
import FileUpload from "@/components/file-upload.vue";
import {apiAbort} from "@/common/apiAbort";
import VizletHeader from "@/components/VizletHeader.vue";
// import ProductCategory from "@/components/ProductCategory.vue";

export default {
  name: "Viz1",
  components: { FileUpload, TabulatorReportTable, Modal, SalesDashboard, SalesDashboardV1,VizletHeader},
  props: {
    viz1: Object,
    styles: String,
    propTime: Date,
    screenlet: Number,
    filterParam: Object,
    selectedFilters: Object,
    width: Number,
    height: Number,
    vizCount: Number,
    filterFlag: Boolean
  },
  watch: {
    $props: {
      handler() {
        console.log("inside viz1 filter", this.$store.state.filterFlag, this.vizCount,this.headerHeight);
        if (this.$store.state.filterFlag === true) {
          console.log("inside viz1 filter")
          // Load the visualization
          this.loadViz().then(() => {
            console.log("loadViz from watch")
            // Emit event to parent when this component finishes loading
            this.$emit('viz-loaded');
          }).catch(error => {
            console.error("Error loading viz:", error);
            this.$emit('viz-loaded'); // Still emit even on error to avoid blocking
          });
          // console.log("inside viz1 filter", this.$store.state.filterFlag);
        }
      },
      deep: true
    },
    headerHeight: {
      handler() {
        this.handleResize();
      },
      immediate: true
    },
    width: {
      handler() {
        this.handleResize();
      },
      immediate: true
    },
    height: {
      handler() {
        this.handleResize();
      },
      immediate: true
    },
    tabulatorData: {
      handler(newData) {
        // Delay the execution until the component is fully mounted
        this.$nextTick(() => {
          if (this.$refs.tabulatorReport) {
            this.$refs.tabulatorReport.loadTabulatorData(newData);
          }
        });
      },
      deep: true,
      immediate: true,
    },
    vizHeight:{
      handler() {
        this.handleResize();
      },
      immediate: true
    },
    vizWidth:{
      handler() {
        this.handleResize();
      },
      immediate: true
    },
  },
  data: () => ({
    searchQuery: '',
    originalData: null, // To store unfiltered data
    filtersForDashboard: {},
    showFSButton: true,
    showModal: false,
    download: [],
    cleanedDownload: [],
    headerData: [],
    momentAll: '',
    cmnt: "",
    annotations: [],
    searching: false,
    annotationTitle: "",
    // filterPeriodLevel1:"",
    f: {},
    iconOnChangeFlag: [],
    checkbox: false,
    gridflag: false,
    showValuesFlag: true,
    currentMenuActionIconsData: [],
    mCurrentMenuActionIconsData: [],
    id: `VIZ-${new Date().getTime()}`,
    grid_id: `VIZ-${new Date().getTime()}` + "grid",
    vizletCardStyle: '',
    tooltipTitle: '',
    colorClass: "#41ab5d",
    vizTypeName: '',
    total: null,
    showErrorModal: false,
    title:"",
    tabulatorData: [],
    tabFlag: false,
    salesData: [],
    downloadLoading: false,
    downloadResponse: null,
    isCollapsed: false,
    showResize: false,
    isResizing: false,
    startWidth: 0,
    startHeight: 0,
    startX: 0,
    startY: 0,
    vizWidth: 0,
    vizHeight: 0,
    chartCleanup: null
  }),
  computed: {
    dynamicStyle() {
      const isSmallScreen = window.innerWidth <= 1300;

      // Fallback: if no headerHeight, use vh directly
      if (!this.headerHeight) {
        return {
          maxHeight: isSmallScreen ? "81vh" : "74vh",
          overflow: "auto",
        };
      }

      // Adjust based on screen size
      const baseVH = isSmallScreen ? 81 : 82;

      return {
        maxHeight: `calc(${baseVH}vh - ${this.headerHeight}px)`,
        overflow: "auto",
      };
    },
    fixedScreen() {
      return this.$store.state.fixedScreen;
    }
  },
  beforeDestroy() {
    console.log("clen",this.chartCleanup);
    if (typeof this.chartCleanup === 'function') {
      console.log("Cleaning up ETL Chart intervals...");
      this.chartCleanup(); // This calls your clearInterval logic
    }
  },
  methods: {
    refresh(){
      this.$emit('refresh')
      this.loadViz()
    },
    startBorderResize(e, direction = 'se') {
      this.isResizing = true;
      this.resizeDirection = direction;

      const card = this.$refs.screen;
      if (card) {
        const rect = card.getBoundingClientRect();
        this.startWidth = rect.width;
        this.startHeight = rect.height;
        this.startX = e.clientX;
        this.startY = e.clientY;

        document.addEventListener('mousemove', this.handleBorderResize);
        document.addEventListener('mouseup', this.stopBorderResize);
      }
      e.preventDefault();
    },

    handleBorderResize(e) {
      if (!this.isResizing) return;

      const deltaX = e.clientX - this.startX;
      const deltaY = e.clientY - this.startY;

      let newWidth = this.startWidth;
      let newHeight = this.startHeight;

      // Handle different resize directions
      switch (this.resizeDirection) {
        case 'e': // east (right)
          newWidth = this.startWidth + deltaX;
          break;
        case 's': // south (bottom)
          newHeight = this.startHeight + deltaY;
          break;
        case 'se': // south-east (bottom-right)
          newWidth = this.startWidth + deltaX;
          newHeight = this.startHeight + deltaY;
          break;
      }

      // Apply minimum dimensions
      this.vizWidth = Math.max(200, newWidth);
      this.vizHeight = Math.max(150, newHeight);

      this.updateCardSize();
    },

    stopBorderResize() {
      this.isResizing = false;
      this.resizeDirection = null;
      document.removeEventListener('mousemove', this.handleBorderResize);
      document.removeEventListener('mouseup', this.stopBorderResize);
      this.handleResize(); // Trigger your existing resize logic
    },

    updateCardSize() {
      const card = this.$refs.screen;
      if (card) {
        card.style.setProperty("flex", "0 0 auto", "important");
        card.style.setProperty("width", `${this.vizWidth}px`, "important");
        card.style.setProperty("height", `${this.vizHeight}px`, "important");
      }

      this.vizletCardStyle = {
        minWidth: `${this.vizWidth}px !important`,
        height: `${this.vizHeight}px !important`,
      };
      this.handleResize()
    },

    resetFilter() {
      this.$store.commit('setResetSortFlag', true);
      this.handleResize()
    },
    toggleCardWidth() {
      this.$store.commit('setFixedScreenFlag');
      this.handleResize()
    },
    handleResize() {
        this.$nextTick(() => {
          let allVizType = this.$store.state.vizType;
          let v = this.viz1;
          let margin = {
            top: v.pmTop,
            right: v.pmRight,
            bottom: v.pmBottom,
            left: v.pmLeft,
          };

          let vizId = v.vizletId;
          let filter = allVizType.find((t) => t.viztypeId === vizId);
          let vizname = filter?.viztypeClassName;
          let vizFunction = filter?.viztypeFunctionName;
          let resetfilter = this.$store.state.resetSortFlag

          let divId = this.vizTypeName === 'TableBar' ? this.$refs.r1c2 : this.$refs.r1c1;

          if (!divId) {
            console.warn('DOM element for chart not ready:', this.vizTypeName);
            return;
          }

          let vizunit = v.vizletSequence;

          let getChartInfo = (vizunit) => {
            if (!v || v.length === 0)
              return new FwVizChartInfo(vizunit, margin, {}, false, []);
            return new FwVizChartInfo(vizunit, margin, v, v.visibleFlag, v);
          };

          this.position = getChartInfo(vizunit);

          let chartData = this.position;
          const convertedObj = this.convertValuesToStrings(this.$store.state.lbWhereCond[this.screenlet]);
          this.filtersForDashboard = convertedObj;

          let passedParam = {
            ...convertedObj,
            ...this.filterParam
          };

          this.$commonFn.renderChartCompare(
              vizname,
              chartData,
              divId,
              vizFunction,
              this.tabulatorData,
              passedParam,
              this.checkbox,
              this.gridflag,
              this.showValuesFlag,
              resetfilter
          );
        });
    },
    handleSearch(searchQuery) {
      // Use parameter if provided, otherwise use internal state
      const queryToUse = searchQuery !== undefined ? searchQuery : this.searchQuery;

      if (!queryToUse.trim()) {
        // If search is empty, show original data
        this.resetSearch();
        return;
      }

      const query = queryToUse.toLowerCase();

      if (this.viz1.viztypeName === 'TableBar') {
        this.filterTableBarData(query);
      } else if (this.viz1.viztypeName === 'Tabulator') {
        this.filterTabulatorData(query);
      }
    },
    filterTableBarData(query) {
      // Filter logic for TableBar
      this.filteredData = this.originalData.filter(item => {
        return Object.values(item).some(val =>
            String(val).toLowerCase().includes(query)
        );
      });
      let v = this.viz1;
      // console.log("this.viz1", this.viz1);
      this.tooltipTitle = v.highLowBetter
      this.vizTypeName = v.viztypeName
      // let margin = {
      //   top: v.pmTop,
      //   right: v.pmRight,
      //   bottom: v.pmBottom,
      //   left: v.pmLeft,
      // };
      let allVizType = this.$store.state.vizType;
      let vizId = v.vizletId;
      let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
      // let vizname = filter.viztypeClassName
      let vizFunction = filter.viztypeFunctionName;

      // Re-render chart with filtered data
      this.$commonFn.renderChartCompare(
          this.vizTypeName,
          this.position,
          this.$refs.r1c2,
          vizFunction,
          this.filteredData,
          // this.passedParam,
          this.checkbox,
          this.gridflag,
          this.showValuesFlag
      );
    },
    filterTabulatorData(query) {
      // For Tabulator, we can use its built-in filtering
      if (this.$refs.tabulatorReport) {
        this.$refs.tabulatorReport.setFilter(query);
      }
    },
    resetSearch() {
      this.searchQuery = '';
      let v = this.viz1;
      this.vizTypeName = v.viztypeName
      let allVizType = this.$store.state.vizType;
      let vizId = v.vizletId;
      let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
      let vizFunction = filter.viztypeFunctionName;
      if (this.viz1.viztypeName === 'TableBar' && this.originalData) {
        // Restore original data for TableBar
        this.$commonFn.renderChartCompare(
            this.vizTypeName,
            this.position,
            this.$refs.r1c2,
            vizFunction,
            this.originalData,
            // this.passedParam,
            this.checkbox,
            this.gridflag,
            this.showValuesFlag
        );
      } else if (this.viz1.viztypeName === 'Tabulator' && this.$refs.tabulatorReport) {
        // Clear Tabulator filters
        this.$refs.tabulatorReport.clearFilter();
      }
    },
    toggleCardBody() {
      this.isCollapsed = !this.isCollapsed;
      // If you need to redraw charts when expanding
      if (!this.isCollapsed) {
        this.$nextTick(() => {
          // Redraw any charts if needed
          if (this.viz1.chart) {
            this.viz1.chart.resize().redraw();
          }
        });
      }
    },
    async downloadData() {
      this.$refs['download-modal'].show();
      this.downloadLoading = true;

      try {
        let datas = this.$store.state.lbWhereCond[this.screenlet];
        let v = this.viz1;

        if (v.reportHeaderColumnDp && (v.downloadsqlId === null || v.downloadsqlId === '')) {
          datas["reportHeaderColumnDp"] = v.reportHeaderColumnDp;
        }

        let vizTitle = v.vizletTitleDpName ? encodeURIComponent(v.vizletTitleDpName.replaceAll('/', '-')) : 'undefined';
        this.momentAll = `${moment().format('YYYY-MM-DD_hhmm')}_${v.viztypeName}`;
        const fileName = this.$store.state.user.userId + '_' + v.vizletTitleDpName + '_' + `${moment().format('YYYY-MM-DD_hhmm')}`

        var url = '';
        if (v.downloadsqlId === null) {
          if (this.viz1.viztypeName === 'Tabulator'){
            const tabulatorTable = this.$refs.tabulatorReport;
            tabulatorTable.downloadExcel(fileName)
            console.log("data download from viz")

            this.$nextTick(()=>{
              this.downloadLoading = false;
              this.$refs['download-modal'].hide();
            })

            return;
          }else {
            url = '/api/fetchCsvWithParam/' + v.datasqlId + '/' + vizTitle;
          }
        } else {
          url = '/api/fetchCsvWithParam/' + v.downloadsqlId + '/' + vizTitle;
        }


        console.log("response", response); // REMOVE responseType: 'blob' - let axios detect the content type
        const controller = apiAbort.new();
        const response = await axios.post(url, datas, {
          signal:controller.signal,
          headers: {
            'info-params': JSON.stringify({
              menuId: this.$route.params.menuId,
              submenuId: this.$route.params.submenuId
            }),
            'Content-Type': 'application/json'
          }
          // REMOVED: responseType: 'blob'
        });

        console.log("response headers", response.headers);
        console.log("response data type", typeof response.data);

        this.$refs['download-modal'].hide();
        this.downloadLoading = false;

        // Check content type to determine if it's CSV or JSON
        const contentType = response.headers['content-type'];

        if (contentType && contentType.includes('text/csv')) {
          // Direct download - it's a CSV file
          // console.log("Direct download - CSV file");
          const blob = new Blob([response.data], { type: 'text/csv' });
          this.downloadBlob(blob, this.$store.state.user.userId + '_' + v.vizletTitleDpName + '_' + `${moment().format('YYYY-MM-DD_hhmm')}` + ".csv");
        } else if (response.data && response.data.jobId) {
          // Async processing - it's JSON with jobId
          // console.log("Async processing - jobId:", response.data.jobId);
          await this.pollExportStatus(response.data.jobId);
        } else {
          // Unexpected response
          console.error("Unexpected response:", response);
          this.$bvToast.toast('Unexpected response from server', {
            title: 'Error',
            variant: 'danger'
          });
        }

      } catch (e) {
        this.downloadLoading = false;
        this.$refs['download-modal'].hide();
        this.$bvToast.toast(`Error in loading the data for download`, {
          title: 'Error',
          autoHideDelay: 5000,
          variant: 'danger'
        });
        console.error('error in loading download data', e);
      }
    },

    async pollExportStatus(jobId){
      this.$bvToast.toast(`We've started your download. Since it's a large file,
        it's processing in the background. You'll get a notification as soon as it's finished and available in your downloads.`,
          {
        title: 'Processing',
        autoHideDelay: 10000,
        variant: 'info'
      });

      const checkStatus = async () => {
        try {
          const response = await axios.get(`/api/exportStatus/${jobId}`);
          const status = response.data;

          if (status.status === 'COMPLETED') {
            // Download the file
            const downloadResponse = await axios.get(`/api/downloadExport/${jobId}`, {
              responseType: 'blob'
            });
            // console.log("download export response", downloadResponse);

            this.momentAll = `${moment().format('YYYY-MM-DD_hhmm')}`;
            // Extract filename from Content-Disposition header if available
            let filename = this.$store.state.user.userId + '-' + this.viz1.vizletTitleDpName + '-' + this.momentAll +'.csv';
            // console.log("filename",filename)

            this.downloadBlob(downloadResponse.data, filename);
            this.showSuccess();
          } else if (status.status === 'FAILED') {
            this.showError(status.errorMsg || 'Export failed');
          } else {
            // Still processing, check again in 3 seconds
            setTimeout(checkStatus, 10000);
          }
        } catch (e) {
          this.showError('Error checking export status');
        }
      };

      await checkStatus();
    },

    downloadBlob(blob, fileName) {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },

    showError(message) {
      this.$bvToast.toast(message, { variant: 'danger',autoHideDelay: 8000 });
    },

    showSuccess() {
      this.showErrorModal = true;
      this.title = "Your download has finished! You can find the file in your download folder."
    },

    // confirmDownload() {
    //   /* if (this.viz1.viztypeName === 'Tabulator') {
    //      const tabulatorTable = this.$refs.tabulatorReport;
    //      if (tabulatorTable) {
    //        tabulatorTable.downloadCSV();
    //      }
    //    } */
    //   if (this.downloadResponse && this.downloadResponse.data.url) {
    //     // Fix the URL by removing any double slashes
    //     let downloadUrl = this.downloadResponse.data.url;
    //     if (downloadUrl.startsWith('/')) {
    //       downloadUrl = downloadUrl.substring(1); // Remove leading slash
    //     }
    //
    //     // Construct the full URL properly
    //     const baseUrl = process.env.VUE_APP_API.endsWith('/')
    //         ? process.env.VUE_APP_API.slice(0, -1)
    //         : process.env.VUE_APP_API;
    //
    //     const fullUrl = `${baseUrl}/${downloadUrl}`;
    //     window.open(fullUrl, '_blank');
    //   }
    // },
    loadViz() {
      return new Promise((resolve, reject) => {
        try {
          if (this.viz1 && this.viz1.viztypeName !== 'report') {
            this.$store.dispatch("loadState").then(() => {
              // let menuData = this.$store.state.fwConfigMenuScreenRender
              let actionIconsData = this.$store.state.actionIcons

              // ?? checking null value and assigning empty array since models.kt returns null instead of empty list
              var vizletActionIconsSyspkArray = this.viz1.vizletActionIconsSyspkArray ? this.viz1.vizletActionIconsSyspkArray : []
              var mvizletActionIconsSyspkArray = this.viz1.mvizletActionIconsSyspkArray ? this.viz1.mvizletActionIconsSyspkArray : []
              // var vizletActionIconsSyspkArray = currentMenuData[0].vizletActionIconsSyspkArray ? currentMenuData[0].vizletActionIconsSyspkArray : []
              var currentMenuActionIconsData = actionIconsData.filter(r => vizletActionIconsSyspkArray.includes(r.syspk))
              var mCurrentMenuActionIconsData = actionIconsData.filter(r => mvizletActionIconsSyspkArray.includes(r.syspk))

              // sort function for sorting the filtered currentMenuActionIconsData with the reference Array vizletActionIconsSyspkArray
              function sortFuncAI(a, b) {
                return vizletActionIconsSyspkArray.indexOf(a.syspk) - vizletActionIconsSyspkArray.indexOf(b.syspk);
              }

              function msortFuncAI(a, b) {
                return mvizletActionIconsSyspkArray.indexOf(a.syspk) - mvizletActionIconsSyspkArray.indexOf(b.syspk);
              }

              currentMenuActionIconsData.sort(sortFuncAI); //sorting the currentMenuActionIconsData
              mCurrentMenuActionIconsData.sort(msortFuncAI);
              this.currentMenuActionIconsData = currentMenuActionIconsData //need to add in router function
              this.mCurrentMenuActionIconsData = mCurrentMenuActionIconsData
              this.iconOnChangeFlag = Array(this.currentMenuActionIconsData.length).fill(true);
              if (this.$store.state.deviceType === 'Mobile') {
                this.iconOnChangeFlag = Array(this.mCurrentMenuActionIconsData.length).fill(true);
              }

              // this.vizletCardStyle = currentMenuData[0].vizletCardStyle
              if (typeof this.viz1.vizletCardStyle === 'string') {
                // convert "min-width:30rem;" → { minWidth: '30rem' }
                this.vizletCardStyle = this.viz1.vizletCardStyle
                    .split(';')
                    .filter(s => s.trim())
                    .reduce((acc, rule) => {
                      const [key, value] = rule.split(':');
                      if (key && value) {
                        acc[key.trim().replace(/-([a-z])/g, (_, c) => c.toUpperCase())] = value.trim();
                      }
                      return acc;
                    }, {});
              } else {
                this.vizletCardStyle = { ...this.viz1.vizletCardStyle };
              }
              let allVizType = this.$store.state.vizType;
              let v = this.viz1;
              // console.log("this.viz1", this.viz1);
              this.tooltipTitle = v.highLowBetter
              this.vizTypeName = v.viztypeName
              let margin = {
                top: v.pmTop,
                right: v.pmRight,
                bottom: v.pmBottom,
                left: v.pmLeft,
              };

              let vizId = v.vizletId;
              let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
              let vizname = filter.viztypeClassName
              let vizFunction = filter.viztypeFunctionName;
              if (this.vizTypeName == 'TableBar') {
                var divId = this.$refs.r1c2;
              } else {
                divId = this.$refs.r1c1;
              }

              let vizunit = v.vizletSequence;

              let getChartInfo = (vizunit) => {
                let f = v;
                if (f.length === 0)
                  return new FwVizChartInfo(vizunit, margin, {}, false, []);
                return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
              };

              this.position = getChartInfo(vizunit);

              let chartData = this.position;

              // Convert the object
              const convertedObj = this.convertValuesToStrings(this.$store.state.lbWhereCond[this.screenlet]);
              this.filtersForDashboard = convertedObj
              let passedParam = {
                ...convertedObj,
                ...this.filterParam
              };


              var vizValue = vizname === 'ForceLayout' ? 'CommonVizClass' : vizname;
              var url = '/api/fetchDataWithParam/' + chartData.data.datasqlId + '/' + vizValue
              const controller = apiAbort.new()

              axios.post(url, passedParam, {
                signal: controller.signal,
                headers: {
                  'info-params': JSON.stringify({
                    menuId: this.$route.params.menuId,
                    submenuId: this.$route.params.submenuId
                  }),
                  'Content-Type': 'application/json'
                }
              }).then(async resp => {
                console.log("store", this.$store.state.user.userRoleRestriction.menuAccessInclusionArray, resp.data)
                let restrictedArray = this.$store.state.user.userRoleRestriction.menuAccessInclusionArray || [];
                let exclusionArray = this.$store.state.user.userRoleRestriction.menuAccessExclusionArray || [];

// Handle empty/undefined/null/["[]"] cases - all menus allowed
                const isAllMenusAllowed = !restrictedArray ||
                    restrictedArray.length === 0 ||
                    (restrictedArray.length === 1 && restrictedArray[0] === "[]")

                let data = chartData.title === "Browse the Menu" ? resp.data.filter(item => {
                  // If all menus are allowed, return all items
                  if (isAllMenusAllowed) {
                    return true;
                  }
                  // Check if item is in restricted array (any of the dimensions)
                  const isIncluded = restrictedArray.includes(item.dim5_name) ||
                      restrictedArray.includes(item.dim6_name) ||
                      restrictedArray.includes(item.dim8_name);

                  // Check if item is NOT in exclusion array (none of the dimensions should be excluded)
                  const isNotExcluded = !exclusionArray.includes(item.dim5_name) &&
                      !exclusionArray.includes(item.dim6_name) &&
                      !exclusionArray.includes(item.dim8_name);

                  // Return items that are included AND not excluded
                  return isIncluded && isNotExcluded;
                }) : resp.data

                // Check if we should skip chart rendering for specific viztypeNames
                const skipVizTypes = ['fileUpload', 'salesDashboardv1', 'salesDashboard', 'Tabulator'];

                if (skipVizTypes.includes(this.viz1.viztypeName)) {
                  console.log(`Skipping chart render for ${this.viz1.viztypeName}`);
                  // Set the data but don't render chart
                  this.tabulatorData = data;
                  this.originalData = data;
                  this.salesData = data;
                  this.tabFlag = true;
                  // Return early - no chart rendering
                  return;
                }
                // setTimeout(() => {
                this.chartCleanup = await this.$commonFn.renderChartCompare(
                    vizname,
                    chartData,
                    divId,
                    vizFunction,
                    data,
                    passedParam,
                    this.checkbox,
                    this.gridflag,
                    this.showValuesFlag
                );
                this.tabulatorData = data
                this.originalData = data
                this.salesData = data
                this.tabFlag = true
                // }, 300);
              }).catch(error => {
                console.log("error",error.response.data?.error);

                if (error.response) {
                  if (Object.keys(this.filterParam  || {}).length > 0 && !this.selectedFilters?.["Viz Type"]?.Value?.["DataSQL"] && error?.response?.data?.error !== "AuthToken Exception") {
                    // alert("Selected option is not supported");
                    this.showErrorModal = true;
                    this.title = "Selected option is not supported."
                  }
                } else if (error.request) {
                  // No response received from the server
                  console.error("Request error:", error.request);
                  alert("No response received from the server. Please check your connection.");
                } else {
                  // Other errors
                  console.error("Error message:", error.message);
                  alert("An unexpected error occurred. Please try again.");
                }
              });
            });
          }
          setTimeout(() => {
            console.log("Viz loaded for component");
            resolve();
          }, 100);
        } catch (error) {
          reject(error);
        }
      });
    },
    // Function to convert non-string values to strings, excluding null and undefined
    convertValuesToStrings(inputObj) {
      return Object.fromEntries(
          Object.entries(inputObj).map(([key, value]) => {
            if (Array.isArray(value)) {
              // Map over the array and convert each element
              return [key, value.map(item => (item === null || item === undefined ? item : String(item)))];
            } else {
              // Handle non-array values (if any)
              return [key, value === null || value === undefined ? value : String(value)];
            }
          })
      );
    },

    svgToPng() {
      let v = this.viz1;
      var div_id;
      if (this.$refs.r1c1) {
        div_id = this.$refs.r1c1.id;
      } else div_id = this.$refs.r1c2.id
      let svgObject = document.getElementById(div_id);
      let svgDom = svgObject.querySelector('svg');
      svgDom.style.background = 'white';

      function pad2(n) {
        return n < 10 ? '0' + n : n
      }

      var date = new Date();
      // var date_format =  date.getFullYear().toString() + pad2(date.getMonth() + 1) + pad2( date.getDate()) + pad2( date.getHours() ) + pad2( date.getMinutes() ) + pad2( date.getSeconds() ) ;
      var date_format = date.getFullYear().toString() + pad2(date.getMonth() + 1) + pad2(date.getDate()) + pad2(date.getHours()) + pad2(date.getMinutes());
      saveSvgAsPng(svgDom, `${v.menuId}_${v.vizletTitleDpName}_${date_format}.png`);
    },
    handleActionIconFunctionCall(fnName, index) {
      let val = !this.iconOnChangeFlag[index]
      this.$set(this.iconOnChangeFlag, index, val) //Array mutation happens only by set function or other mutation methods like slice,push,pop etc
      this[fnName](this.showFSButton)
    },

    redirectPage(redirect) {
      if (redirect === true) {
        let v = this.viz1;
        window.open(v.drilldownUrl, '_blank')
      }
    },
    fullscreen(showFSButton) {
      if (showFSButton === true) {
        // console.log("fullscreen mood")
        // if (!document.fullscreenElement) {
        this.$refs.screen.requestFullscreen()
        // this.$refs.screen.classList.add('fullscreen');
        if (this.$refs.r1c1) this.$refs.r1c1.classList.add('scrollmenu'); //check whether viz is requesting FS remove its class
        if (this.$refs.r1c2) this.$refs.r1c2.classList.remove('scrollmenuRepo'); // check whether report is requesting FS remove its class
        if (this.$refs.r1c2) this.$refs.r1c2.classList.add('fullscreenRepo');
        /* } else {
             if(this.$refs.r1c1) this.$refs.r1c1.classList.remove('scrollmenu');//check whether viz is requesting FS add its class
             if(this.$refs.r1c2) this.$refs.r1c2.classList.remove('fullscreenRepo'); // check whether report is requesting FS remove its class
           //  this.$refs.screen.classList.remove('fullscreen');
             const document = window.document
             document.exitFullscreen();
         }*/
      } else {
        if (document.exitFullscreen) {
          if (this.$refs.r1c1) this.$refs.r1c1.classList.remove('scrollmenu');//check whether viz is requesting FS add its class
          if (this.$refs.r1c2) this.$refs.r1c2.classList.remove('fullscreenRepo');
          if (this.$refs.r1c2) this.$refs.r1c2.classList.add('scrollmenuRepo');
          this.$refs.screen.classList.remove('fullscreen');
          document.exitFullscreen();
        }
      }
      this.showFSButton = !this.showFSButton
    },

    commentBox: function () {
      let what = this.viz1
      this.cmt = "";
      this.pg = what.screenTitleDpName;
      this.section = what.vizletTitleDpName;
      this.annotationHeader = "User Annotations";
      this.annotationTitle = this.annotationHeader + "-> " + this.pg + "-> " + this.section;
      this.$refs["comment-box"].show();
    },
    postAnnotation: function () {
      const url = "/api/annotation";
      const data = {
        userId: 1,
        userName: "Admin",
        page: this.pg,
        section: this.section,
        comment: this.cmnt,
        isBizAnnon: false
      };
      const controller = apiAbort.new();  // 🔹 create abort controller
      axios.post(url, data ,{
        signal: controller.signal,    // 🔹 attach abort signal
            headers: {
          'Content-Type': 'application/json'
        }
      }).then(() => {
            this.$store.dispatch("loadAnnotations");
            getAnnotationMsgcount();
          },
          (e) => {
            //  this.$commonFn.auditLog(this.viz1.menuSyspk,menu, subMenu, "", "POST", e);
            console.error("error in updating annotations", e);
          }
      );
      const menuDetails = this.$store.state.menuMasterFlat.filter(m => m.menuId === this.viz1.menu_id)
      // console.log("menuDetails", menuDetails);
      this.$commonFn.auditLog(menuDetails[0].syspk, this.viz1.menu_id, menuDetails[0].menuName, this.viz1.vizletTitleDpName, "POST", "Success",this.$store.state.deviceType)
    },
    toggleCheckbox: function () {
      this.$store.dispatch("loadState").then(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.viz1;
        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft,
        };

        //let vizId = v.viztypeId;
        let vizId = v.vizletId;
        let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
        let vizname = filter.viztypeClassName
        let vizFunction = filter.viztypeFunctionName;
        let divId = this.$refs.r1c1;
        let vizunit = v.vizletSequence;

        let getChartInfo = (vizunit) => {
          let f = v;
          if (f.length === 0)
            return new FwVizChartInfo(vizunit, margin, {}, false, []);
          return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
        };

        this.position = getChartInfo(vizunit);

        let chartData = this.position;

        const convertedObj = this.convertValuesToStrings(this.$store.state.lbWhereCond[this.screenlet]);
        let passedParam = {
          ...convertedObj,
          ...this.filterParam
        };
        this.tabulator = passedParam
        var url = '/api/fetchDataWithParam/' + chartData.data.datasqlId + '/' + vizname
        const controller = apiAbort.new();  // 🔹 create abort controller
        axios.post(url, passedParam, {
          signal: controller.signal,    // 🔹 attach abort signal
          headers: {
            'info-params': JSON.stringify({
              menuId: this.$route.params.menuId,
              submenuId: this.$route.params.submenuId
            }),
            'Content-Type': 'application/json'
          }
        }).then(resp => {
          // setTimeout(() => {
          this.$commonFn.renderChartCompare(
              vizname,
              chartData,
              divId,
              vizFunction,
              resp.data,
              passedParam,
              this.checkbox,
              this.gridflag,
              this.showValuesFlag
          );
          // }, 300);
        }).catch(e=>{
          console.error("error",e);
        })
      });
      this.checkbox = !this.checkbox
    },
    showHideValues: function () {
      this.$store.dispatch("loadState").then(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.viz1;
        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft,
        };

        //let vizId = v.viztypeId;
        let vizId = v.vizletId;
        let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
        let vizname = filter.viztypeClassName
        let vizFunction = filter.viztypeFunctionName;
        let divId = this.$refs.r1c1;
        let vizunit = v.vizletSequence;

        let getChartInfo = (vizunit) => {
          let f = v;
          if (f.length === 0)
            return new FwVizChartInfo(vizunit, margin, {}, false, []);
          return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
        };

        this.position = getChartInfo(vizunit);

        let chartData = this.position;

        const convertedObj = this.convertValuesToStrings(this.$store.state.lbWhereCond[this.screenlet]);
        let passedParam = {
          ...convertedObj,
          ...this.filterParam
        };
        var url = '/api/fetchDataWithParam/' + chartData.data.datasqlId + '/' + vizname
        const controller = apiAbort.new();  // 🔹 create abort controller
        axios.post(url, passedParam, {
          signal: controller.signal,    // 🔹 attach abort signal
          headers: {
            'info-params': JSON.stringify({
              menuId: this.$route.params.menuId,
              submenuId: this.$route.params.submenuId
            }),
            'Content-Type': 'application/json'
          }
        }).then(resp => {
          // setTimeout(() => {
          this.$commonFn.renderChartCompare(
              vizname,
              chartData,
              divId,
              vizFunction,
              resp.data,
              passedParam,
              this.checkbox,
              this.gridflag,
              this.showValuesFlag
          );
          // }, 300);
        }).catch(e=>{
          console.error("error",e);
        })
      });
      this.showValuesFlag = !this.showValuesFlag
    },
    gridlinetoggle: function () {
      this.$store.dispatch("loadState").then(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.viz1;
        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft,
        };

        //let vizId = v.viztypeId;
        let vizId = v.vizletId;
        let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
        let vizname = filter.viztypeClassName
        let vizFunction = filter.viztypeFunctionName;
        let divId = this.$refs.r1c1;
        let vizunit = v.vizletSequence;
        let getChartInfo = (vizunit) => {
          let f = v;
          if (f.length === 0)
            return new FwVizChartInfo(vizunit, margin, {}, false, []);
          return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
        };
        this.position = getChartInfo(vizunit);

        let chartData = this.position;

        const convertedObj = this.convertValuesToStrings(this.$store.state.lbWhereCond[this.screenlet]);
        let passedParam = {
          ...convertedObj,
          ...this.filterParam
        };
        var url = '/api/fetchDataWithParam/' + chartData.data.datasqlId + '/' + vizname
        const controller = apiAbort.new();  // 🔹 create abort controller
        axios.post(url, passedParam, {
          signal: controller.signal,    // 🔹 attach abort signal
          headers: {
            'info-params': JSON.stringify({
              menuId: this.$route.params.menuId,
              submenuId: this.$route.params.submenuId
            }),
            'Content-Type': 'application/json'
          }
        }).then(resp => {
          // setTimeout(() => {
          this.$commonFn.renderChartCompare(
              vizname,
              chartData,
              divId,
              vizFunction,
              resp.data,
              passedParam,
              this.checkbox,
              this.gridflag,
              this.showValuesFlag
          );
          // }, 300);
        }).catch(e=>{
          console.error("error",e);
        })
      });
      this.gridflag = !this.gridflag
    },
    forwardtoggle: function () {
      this.$store.dispatch("loadState").then(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.viz1;
        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft,
        };

        //let vizId = v.viztypeId;
        let vizId = v.vizletId;
        let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
        let vizname = filter.viztypeClassName
        let vizFunction = filter.viztypeFunctionName;
        let divId = this.$refs.r1c1;
        let vizunit = v.vizletSequence;

        let getChartInfo = (vizunit) => {
          let f = v;
          if (f.length === 0)
            return new FwVizChartInfo(vizunit, margin, {}, false, []);
          return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
        };
        this.position = getChartInfo(vizunit);

        let chartData = this.position;

        const convertedObj = this.convertValuesToStrings(this.$store.state.lbWhereCond[this.screenlet]);
        let passedParam = {
          ...convertedObj,
          ...this.filterParam
        };
        var url = '/api/fetchDataWithParam/' + chartData.data.datasqlId + '/' + vizname
        const controller = apiAbort.new();  // 🔹 create abort controller
        axios.post(url, passedParam, {
          headers: {
            signal: controller.signal,    // 🔹 attach abort signal
            'info-params': JSON.stringify({
              menuId: this.$route.params.menuId,
              submenuId: this.$route.params.submenuId
            }),
            'Content-Type': 'application/json'
          }
        }).then(resp => {
          // setTimeout(() => {
          this.$commonFn.renderChartCompare(
              vizname,
              chartData,
              divId,
              vizFunction,
              resp.data,
              passedParam,
              this.checkbox,
              this.gridflag,
              this.showValuesFlag
          );
          // }, 300);
        }).catch(e=>{
          console.error("error",e);
        })
      });
      this.forwardflag = !this.forwardflag
    },

    fetchTotal: function () {
      setTimeout(async () => {
        if (this.viz1.viztypeName === "Tabulator" && this.viz1.vizletMiddleTitleFlag) {
          const dataSqlId = this.viz1.datasqlId;
          const controller = apiAbort.new();  // 🔹 create abort controller
          await axios.post(`/api/fetchDataWithParam/${dataSqlId}/CommonVizClass`, {}, {
            signal: controller.signal,    // 🔹 attach abort signal
            headers: {
              'info-params': JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId
              }),
              'Content-Type': 'application/json'
            }
          }).then(response=>{
            this.totalCountTabulator = response.data.length
            this.total = this.totalCountTabulator
          }).catch(e=>{
            console.error("error",e);
          })
        } else if (this.viz1.viztypeName === "multiplePieChart_2" && this.viz1.vizletMiddleTitleFlag) {
          let datas = this.$store.state.lbWhereCond[this.screenlet]
          const controller = apiAbort.new();  // 🔹 create abort controller
          axios.post('/api/fetchDataWithParam/' + this.viz1.vizSpecific4 + '/Any', datas, {
            signal: controller.signal,    // 🔹 attach abort signal
            headers: {
              'info-params': JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId
              }),
              'Content-Type': 'application/json'
            }
          }).then(res => {

            let data2 = res.data;
            this.total = data2.rowsData[0].metric1;
          }, () => {
          }).catch(e=>{
            console.error("error",e);
          })
        }
      }, 300);
    },
    fetchTotal2: function () {
      setTimeout(() => {
        if (this.viz1.viztypeName !== "multiplePieChart_2" && this.viz1.vizletMiddleTitleFlag) {
          let datas = this.$store.state.lbWhereCond[this.screenlet]
          const controller = apiAbort.new();  // 🔹 create abort controller
          axios.post('/api/fetchDataWithParam/' + this.viz1.datasqlId + '/Any', datas, {
            signal: controller.signal,    // 🔹 attach abort signal
            headers: {
              'info-params': JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId
              }),
              'Content-Type': 'application/json'
            }
          }).then(res => {

            let data2 = res.data;
            this.total = d3.sum(data2.rowsData, function (d) {
              return d.metric1;
            });
          }, () => {
          }).catch(e=>{
            console.error("error",e);
          })
        }
      }, 300);
    },
    format: function (num) {
      if (this.viz1?.clientId == 3 || this.viz1?.clientId == 30 || this.viz1?.clientId == 40 || this.viz1?.clientId == 70 || this.viz1?.clientId == 5) {
        if (Math.abs(num) >= 1000000000) {
          return (num / 1000000000).toFixed(2).replace(/\.0$/, '') + ' HCr';
        }
        if (Math.abs(num) >= 10000000) {
          return (num / 10000000).toFixed(2).replace(/\.0$/, '') + ' Cr';
        }
        if (Math.abs(num) >= 100000) {
          return (num / 100000).toFixed(2).replace(/\.0$/, '') + ' L';
        }
        if (Math.abs(num) >= 1000) {
          return (num / 1000).toFixed(2).replace(/\.0$/, '') + ' K';
        }
        if (Math.abs(num) < 1000 && Math.abs(num) % 1 !== 0) {
          return num.toFixed(2);
        }
        return num;
      } else {
        if (Math.abs(num) >= 1000000000000) {
          return (num / 1000000000000).toFixed(1).replace(/\.0$/, '') + ' T';
        }
        if (Math.abs(num) >= 1000000000) {
          return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + ' B';
        }
        if (Math.abs(num) >= 1000000) {
          return (num / 1000000).toFixed(1).replace(/\.0$/, '') + ' M';
        }
        if (Math.abs(num) >= 1000) {
          return (num / 1000).toFixed(1).replace(/\.0$/, '') + ' K';
        }
        if (Math.abs(num) < 1000 && Math.abs(num) % 1 !== 0) {
          return num.toFixed(2);
        }
        return num;
      }
    }
  },
  created() {
    // console.log("checkinh viz ", this.vizCount)
    this.fetchTotal();
    this.fetchTotal2();
    this.format();
    this.loadViz().then(() => {
      console.log("loadViz from created")
      // Emit event to parent when this component finishes loading
      this.$emit('viz-loaded');
    }).catch(error => {
      console.error("Error loading viz:", error);
      this.$emit('viz-loaded'); // Still emit even on error to avoid blocking
    });
  },
}

</script>
<style>
.cobackground {
  fill: #eee;
}

.fixed-screen-width {
  @media (min-width: 576px) {
    width: 55vw;
  }
}

/* When vizCount == 1 */
.single-viz-height-banner-true {
  min-height: 80vh;
}

.single-viz-height-banner-false {
  min-height: 87vh;
}

/* When vizCount != 1 */
.single-viz-max-height-banner-true {
  max-height: 80vh;
}

.single-viz-max-height-banner-false {
  max-height: 87vh;
}


text.active {
  fill: red;
}

.custom-icon {
  background-color: black;
  color: white;
  border-radius: 50%;
  border: 1px solid black
}


#full-screen {
  display: block;
  z-index: 1;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}

.fullscreen {
  overflow: auto;
  white-space: nowrap;
  height: 500px;
}

.fullscreenRepo {
  overflow: auto;
  white-space: nowrap;
  height: 900px;
}

.scrollmenu {
  max-height: 86vh;
  overflow: auto;
}

.scrollmenu2 {
  overflow: auto;
  white-space: nowrap;
  max-height: 74vh;
}

.my-custom-tooltip1 {
  background-color: transparent !important;
  padding: 10px !important;
  border: none !important;
  box-shadow: none !important;
}

.my-custom-tooltip1 .tooltip-inner {
  border: 1px solid black;
  background-color: white;
  color: black;
  max-width: 1150px; /* Set max width */
  max-height: 300px; /* Set max height to enable scrolling */
  overflow-y: auto; /* Enable vertical scrollbar */
  pointer-events: auto; /* Allow interaction with tooltip content */
  font-size: 16px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

/* Prevent hiding the tooltip when hovering into the content */
.my-custom-tooltip1:hover {
  display: block !important; /* Ensure the tooltip stays visible */
}

.h1tag {
  font-size: 18px;
}

@media (max-width: 1500px) and (min-width: 1301px) {
  .my-custom-tooltip1 .tooltip-inner {
    max-width: 950px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}


@media (max-width: 1300px) and (min-width: 1251px) {
  .my-custom-tooltip1 .tooltip-inner {
    max-width: 900px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1250px) and (min-width: 1201px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 850px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1200px) and (min-width: 1151px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 800px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1150px) and (min-width: 1101px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 750px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1100px) and (min-width: 1051px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 700px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1050px) and (min-width: 1001px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 650px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}


@media (max-width: 1000px) and (min-width: 951px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 600px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 950px) and (min-width: 901px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 550px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 900px) and (min-width: 851px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 500px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 850px) and (min-width: 801px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 450px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 800px) and (min-width: 768px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 420px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }


}


@media (max-width: 768px) and (min-width: 701px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 580px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}


@media (max-width: 700px) and (min-width: 651px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 530px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 650px) and (min-width: 601px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 480px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 600px) and (min-width: 551px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 420px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 550px) and (min-width: 501px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 380px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 500px) and (min-width: 481px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 350px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 330px; /* Further reduce the width for very small screens */
    font-size: 16px; /* Further adjust font size for very small screens */
  }

  .h1tag {
    font-size: 18px;
  }

}


.scrollmenuRepo {
  max-height: 74vh; /*81*/
  overflow: auto;
}

.scrollmenuRepoFull {
  max-height: 81vh;
  overflow: auto;
}


[v-cloak] .v-cloak--hidden {
  display: none !important;
}

.table.table-xs td,
.table.table-xs th {
  padding: .2em;
  font-size: .8rem;
}

.screen {
  position: relative;
  resize: none;
  overflow: hidden;
  min-width: 300px;
  min-height: 200px;
}


.r1c2true {
  max-height: 74vh;
  overflow: auto;
}

.r1c2false {
  max-height: 81vh;
  overflow: auto;
}

.multi-viz {
  margin-right: 7px;
  height: 100%;
  overflow: auto;
}

.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
  cursor: se-resize;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.5);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Border resize handles */
.resize-border {
  position: absolute;
  z-index: 5;
}


.resize-border-right {
  top: 5px;
  right: 0;
  bottom: 5px;
  width: 5px;
  cursor: e-resize;
}

.resize-border-bottom {
  bottom: 0;
  left: 5px;
  right: 5px;
  height: 5px;
  cursor: s-resize;
}


.card.resizing * {
  pointer-events: none;
}

.tab-indicator {
  font-size: 0.7em;
  padding: 3px 8px;
}

</style>